import { Component } from 'react';
import AuthApis from '../hepler/authApis.service';
import { toast } from 'react-toastify';
import { Dialog, DialogContent, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { postMessage } from '../utils/common.utils';
import {
	captureOtpPageLoad,
	captureOtpInputStart,
	captureOtpVerificationAttempt,
	captureOtpVerificationResult,
	captureOtpInputTriggered,
	captureOtpInputProgress,
	calculateOtpProgressMetrics,
	shouldTrackOtpProgress,
	captureConsentRenewalOtpPageLoad,
	captureConsentRenewalOtpInputStart,
	captureConsentRenewalOtpVerificationAttempt,
	captureConsentRenewalOtpVerificationResult,
	captureConsentRenewalOtpInputTriggered,
	captureConsentRenewalOtpInputProgress,
} from '../utils/analytics/posthog.utils';
import {
	Avatar,
	Box,
	Button,
	Chip,
	Icon,
	Link,
	Stack,
	TextField,
	Typography,
} from '@mui/material';
import LoginRight from './Login/LoginRight';
import SetTheme from './common/SetTheme';
import CircularProgress from '@mui/material/CircularProgress';
import DialogBox from './Dialog Box/Dialog Box';
import DenyConsent from './Accounts/DenyConsent';
import LoginRightContent from './Login/LoginRightContent';
import loginLeftStyles from './Login/LoginLeft.styles';
import Expired from './Expired';
import loginStyles from './Login/Login.styles';
import ConsentListContext from './Context/ConsentContext';
import finvuLogo from '../assets/finvuLogoNew.png';
import LockIcon from '@mui/icons-material/Lock';
import { getFiTypesHash } from '../hepler/functions';
import LoginFooter from './Sections/LoginFooter';
import StepperBar from './common/Stepper';
import StepperContext from './Context/StepperContext';
import { redirectAccountRestrictionsValidator } from '../utils/targetedAccounts.utils';
import LoginOtpGroupedField from './Login/LoginOtpGroupedField';
import Drawer from './Drawer/Drawer';
import { getOtpPageHeading, getOtpPageSubHeading, decodeBase64, parseAdditionalParams, handleRedirect } from '../utils/login.utils';
import { processCompleteEntityConfig } from '../utils/entityConfig.utils';
import { withTranslation } from '../hoc/withTranslation';
import Footer from './Sections/Footer';
import TrustMarker from './common/TrustMarker';

class Login extends Component {
	static contextType = ConsentListContext;
	constructor(props) {
		super(props);
		const queryParams = new URLSearchParams(window.location.search);		
		this.ecreq = queryParams.get('ecreq');
		this.reqdate = queryParams.get('reqdate');
		this.fi = queryParams.get('fi')
			? queryParams.get('fi').split(' ').join('+')
			: null;
		this.requestorType = queryParams.get('requestorType')
			? queryParams.get('requestorType')
			: null;
		global.requestorType = queryParams.get('requestorType')
			? queryParams.get('requestorType')
			: null;
		this.fips = queryParams.get('fip')
			? window.atob(queryParams.get('fip'))
			: null;
		this.channelId = queryParams.get('channelId') ?? null;
		this.language = queryParams.get('language') ?? null;
		this.additionalParams = queryParams.get('additionalParams') ?? null;
		global.isAddAccount = queryParams.get('isAddAccount') ? true : false;
		this.profile = queryParams.get('profile') ?? null;
		this.encryptedConsentId = queryParams.get('consentId') ?? null;
		this.reviewConsentParams = queryParams.get('reviewConsentParams') ?? null;
		this.otpPageHeading = "";
		this.otpPageSubHeading = "";
		this.encryptedDisplayName = queryParams.get('displayName') ?? null;
		global.renewConsentId = queryParams.get('renewConsentId') ?? null;
		this.isConsentRenewal = queryParams.get('isConsentRenewal')?.toLowerCase();
		this.state = {
			time: 60,
			OTP: '',
			isResend: true,
			isOpenSheet: false,
			isDisable: false,
			disableType: '',
			theme: undefined,
			mobileNo: '',
			consentRequestList: [],
			showDetails: false,
			error: '',
			isExpired: false,
			consentList: [],
			showTermsModal: false,
			isCheckValid: false,
			errors: {},
			pageLoadTime: null,
			verificationAttempts: 0,
			otpTriggerCount: 0,
			lastInputTime: null,
			correctionCount: 0,
			consentDetailList: [],
			reviewConsentFlow: false,
			consentId: null,
			name: null,
			loginStage:'',
			isSNAConfigured:false,
			showSNADrawer: false,
			showCancelDialog: false,
			showCancelDrawer: false
		};
		this.number = null;
		this.authApis = new AuthApis();
		this.hasTrackedInputStart = false;
	}
	componentDidMount() {
		// Track page load time immediately
		const pageLoadTime = performance.now();
		this.setState({ pageLoadTime });
	}
	componentDidUpdate(prevProps) {
		if (prevProps.location.pathname !== this.props.location.pathname) {
			if (this.props.history.action === 'POP') {
				window.confirm(
					'Are you sure to go back ? Consent will not be actioned.'
				);
			}
		}
		// Only call getFiuInfo when sdkReady transitions from false to true
		if (!prevProps.sdkReady && this.props.sdkReady) {
			if (
				!this.props?.location?.state?.fromTerm &&
				!this.props.redirectToVersion
			) {
				this.getFiuInfo();
			}
		}
	}
	initiate = () => {
		// if (this.state.time !== 0) {
		this.setState((prevState, prevProps) => ({
			time: prevState.time - 1,
		}));
		if (this.state.time === 0) {
			clearInterval(this.id);
			this.setState({ time: 60, isResend: true });
		}
		// }
	};
	getFiuInfo = () => {
		this.props.updateInitialLoader(true);
		let options = {};
		if(global.renewConsentId){
			options.encryptedConsentId = global.renewConsentId;
		}
		if(this.encryptedConsentId){
			options.encryptedConsentId = this.encryptedConsentId;
		}
		if(this.encryptedDisplayName){
			options.encryptedDisplayName = this.encryptedDisplayName;
		}
		this.authApis.getFiuInfo(this.ecreq, this.reqdate, this.fi, this.requestorType, options)
			.then((res) => {
				if (res?.payload?.status === 'SUCCESS') {
					this.props.toggleTimer();
					let entityId = res.payload?.entityInfo?.entityId;
					let no = res.payload?.userIdOrMobileNo;
					this.setState({ mobileNo: no });
					this.setState({ reviewConsentFlow: res.payload?.consentIdReferenceValid });
					this.setState({ consentId: res.payload?.consentIdReference });
					this.setState({ consentDetailList: res.payload?.consentDetails });
					this.setState({ name: res.payload?.displayName });
				global.institutionType = res.payload?.institutionType;
				global.redirectUrl = res.payload?.redirectUrl;
				global.encryptedres = res.payload?.encryptedres;
				global.resDate = res.payload?.resDate;
				global.encryptedFiId = res.payload?.encryptedFiId;
				global.redirectAccountRestrictions = redirectAccountRestrictionsValidator(res.payload?.accounts);
				// Set targeted discovery mode flag if restrictions exist
				if (global.redirectAccountRestrictions) {
					global.isTargetedDiscoveryMode = true;
				}
				this.fips = res.payload.fips ? res.payload.fips : this.fips;
					global.entityName = res.payload?.entityInfo?.entityName;
					global.mobileNumber = res.payload?.mobileNumber;

					if (res.payload?.consentIdReference && global.renewConsentId && this.isConsentRenewal === 'true') {
						global.renewConsentId = res.payload.consentIdReference;
					}

					if (entityId) {
						// this.sendOtp()
						global.entityId = entityId;
						this.getConfigInfo(entityId);
					} else {
						this.props.updateInitialLoader(false);
						// this.props.history.push(`/error`)
						if (res?.code === undefined || res?.code === null || res?.code === "") {
							toast.error(res?.message);
						} else {
							toast.error(this.props.t(`errors.code.${res.code}`));
						}
						if (res.status === 'FAILURE') {
							postMessage('session', 'FAILURE');
						} else if (res.status === 'ERROR' ) {
							postMessage('session', 'ERROR');
						}
					}
				}
				 else {
					global.redirectUrl = res?.message?.redirectUrl;
					global.encryptedres = res?.message?.encryptedres;
					global.resDate = res?.message?.resDate;
					global.encryptedFiId = res?.message?.encryptedFiId;
					if (res?.code === undefined || res?.code === null || res?.code === "") {
						toast.error(res.message);
					} else {
						toast.error(this.props.t(`errors.code.${res.code}`));
					}
					this.setState({ isExpired: true });
					this.props.updateInitialLoader(false);
				}
			});
	};
	getConfigInfo = (entityId) => {
		let redirectToVersion = true;
		this.authApis.fiuSdkConfig(entityId).then((res) => {
			if (res?.status === 'SUCCESS') {
				// Gateway logic
				const environment = process.env.REACT_APP_ENVIRONMENT;
				const version = res.entityConfig.sdkOptions.version;
				const defaultVersion = process.env.REACT_APP_DEFAULT_VERSION;
				const otherRedirectionUrl =
					process.env.REACT_APP_OTHER_VERSION_REDIRECTION_URL;
				const specialUrl = 'https://sweecar.finvu.in';
				//Case-insensitive version check
				if (version) {
					// sweecar.finvu.in specific code to stop infinite redirection
					if (
						version.toLowerCase() === defaultVersion.toLowerCase() ||
						(version.toLowerCase() === 'v3' &&
							window.location.hostname === 'sweecar.finvu.in')
					) {
						redirectToVersion = false;
					}
				} else {
					if (environment === 'UAT') {
						redirectToVersion = false;
					}
				}
				if (redirectToVersion) {
					const queryParams = new URLSearchParams(window.location.search);
					let redirectionUrl = '';
					// handle null case for version
					if (version && version.toLowerCase() === 'v3') {
						redirectionUrl = specialUrl;
					} else redirectionUrl = otherRedirectionUrl;
					window.location.replace(
						redirectionUrl + '?' + queryParams.toString()
					);
				}

				// Process entity configuration using utility
				const { themeConfig, updatedFips } = processCompleteEntityConfig(
					res,
					this.profile,
					this.fips
				);
				// Update theme config and FIPs
				if (themeConfig) {
					this.props.updateEntityID(themeConfig);
				}
				this.fips = updatedFips;
				// Load entity-specific translations if available
				if (global.alternativeText && this.props.changeLanguage) {
					const currentLanguage = this.props.currentLanguage;
					this.props.changeLanguage(currentLanguage);
				}
			// Validate consentId and isConsentRenewal parameters after successful login
			if (
				(global.renewConsentId && !this.isConsentRenewal) || 
				(!global.renewConsentId && this.isConsentRenewal) ||
				(global.renewConsentId && this.isConsentRenewal && this.isConsentRenewal !== 'true')
			) {
				this.props.updateInitialLoader(false);
				this.props.history.push({
					pathname: `/consent-renew-status`,
					state: {
						status: 'Invalid parameters',
						statusCode: 20,
					},
				});
				return;
			}
				
				// Track page load after we know analytics is enabled
				if (global?.sdkOptions?.analyticsEnabled) {
					const loadTime = performance.now() - this.state.pageLoadTime;
					if (global.renewConsentId && this.isConsentRenewal === 'true') {
						captureConsentRenewalOtpPageLoad({ loadTime });
					} else {
						captureOtpPageLoad({ loadTime });
					}
				}
		} else {
			this.props.updateInitialLoader(false);
		}
		
		this.state.isSNAConfigured = res?.entityConfig?.sdkOptions?.isSNAConfigured;
		if(res?.entityConfig?.sdkOptions?.isSNAConfigured == "true"){
			this.setState({ isDisable: false });
			this.props.updateInitialLoader(false);
			this.state.loginStage = 'PRE_AUTH_CHECK'
		}
		else{
			this.state.loginStage = 'VERIFY_OTP'
			// Handle ai_voice channel journey
			if (this.additionalParams) {
				const decodedParams = decodeBase64(this.additionalParams);
				if (decodedParams && decodedParams !== 'null' && decodedParams !== 'undefined') {
					const parsedParams = parseAdditionalParams(decodedParams);				
					if (parsedParams.channelId === 'AI_VOICE' || parsedParams.channelId === 'ai_voice') {
						this.consentJourneyInitiate(parsedParams.channelId, parsedParams.language);
					}else{
						this.sendOtp(redirectToVersion);
					}
				}else{
					this.sendOtp(redirectToVersion);
				}
			}else{
				this.sendOtp(redirectToVersion);
			}	
		}
		
	});
};

	consentJourneyInitiate = (channelId, language) => {
		this.authApis.consentJourneyInitiate(channelId, language).then((res) => {
			if(res){
				console.log(res, 'res');
				if(res.aiVoiceStatus === 'FAILED' || res.status=== 'FAILURE'){
					console.log('Call Failed');
					this.props.updateInitialLoader(false);
					this.props.history.push({
						pathname: `/consent-status`,
						state: {
							status: 'Call Failed',
							statusCode: 411,
							type: 'voice journey',
						},
					})
				}
				else{
					this.props.updateInitialLoader(false);
					this.voiceJourneyStatus(res.aiVoiceReferenceId, res.userId);
					this.props.history.push({
						pathname: `/voice-journey`,
						state: {
							aiVoiceReferenceId: res.aiVoiceReferenceId,
							userId: res.userId,
						},
					});
				}
			}else{
			    handleRedirect();
			}
		});
	}

	//voice journey status
	voiceJourneyStatus = (aiVoiceReferenceId, userId) => {		
		const POLLING_INTERVAL = 30 * 1000; // 30 seconds
		const MAX_DURATION = 30 * 60 * 1000; // 30 minutes
		
		// Start time for tracking duration
		const startTime = Date.now();
		
		// Function to call the status endpoint
const callStatusCheck = async () => {
		try {
			const res = await this.authApis.consentJourneyStatus(aiVoiceReferenceId, userId);

			const statusMap = {
				'APPROVED': { statusCode: 200, status: 'Consent Approved' },
				'DENY': { statusCode: 201, status: 'Consent Denied' },
			};

			const callEndedMap = {
				'USER_HANGUP': { statusCode: 412, status: 'Call Ended' },
				'AGENT_HANGUP': { statusCode: 413, status: 'Call Ended' },
				'USER_UNAVAILABLE': { statusCode: 414, status: 'Call Ended' },
				'MAX_DURATION': { statusCode: 415, status: 'Call Ended' },
				'VOICEMAIL_REACHED': { statusCode: 416, status: 'Call Ended' },
				'SILENCE_TIMEOUT': { statusCode: 417, status: 'Call Ended' },
				'ERROR_OCCURRED': { statusCode: 418, status: 'Call Ended' },
				'USER_REJECTED': { statusCode: 419, status: 'Call Ended' },
				'CALL_NOT_PICKED':{ statusCode: 420, status: 'Call Ended' },
				'CALL_NOT_CONNECTED' : { statusCode: 421, status: 'Call Ended' },
				'CALL_DROPPED' : { statusCode: 422, status: 'Call Ended' },
				'OTHER':{ statusCode: 423, status: 'Call Ended' },
			};

			let redirectData = null;

			if (res.consentStatus && statusMap[res.consentStatus]) {
				redirectData = statusMap[res.consentStatus];
			} 
			else if (res.callStatus === 'ENDED' && res.disconnectionReason && callEndedMap[res.disconnectionReason]) {
				redirectData = callEndedMap[res.disconnectionReason];
			}

			if (redirectData) {
				clearInterval(intervalId);
				this.props.history.push({
					pathname: `/consent-status`,
					state: {
						status: redirectData.status,
						statusCode: redirectData.statusCode,
						type: 'voice journey',
					},
				});
			} else {
				console.log("Voice journey still in progress, continuing to poll...");
			}

			return res;
		} catch (error) {
			console.error("Error calling consentJourneyStatus endpoint:", error);
		}
	};
		
		// Set up polling interval
		const intervalId = setInterval(async () => {
			const currentTime = Date.now();
			const elapsedTime = currentTime - startTime;
			
			// Check if 30 minutes have passed
			if (elapsedTime >= MAX_DURATION) {
				clearInterval(intervalId);
				console.log("max time limit is reached of 30 min");
				this.props.history.push({
					pathname: `/consent-status`,
					state: {
						status: 'Consent Actioned',
						statusCode: 413,
					},
				});
				return;
			}
			
			// Call the endpoint
			await callStatusCheck();
		}, POLLING_INTERVAL);
			
		// Set up timeout as a safety measure
		setTimeout(() => {
			clearInterval(intervalId);
			console.log("max time limit is reached of 30 min");
			this.props.history.push({
				pathname: `/consent-status`,
				state: {
					status: 'Consent Actioned',
					statusCode: 413,
				},
			});
		}, MAX_DURATION);
		callStatusCheck();
	}

	// Send OTP
	sendOtp = (redirectToVersion = true, nextStep) => {
		if (redirectToVersion) return;
		// Track OTP input trigger before incrementing counter
		const currentTime = performance.now();
		const otpTriggerMetrics = {
			triggerType: this.state.otpTriggerCount === 0 ? 'auto' : 'resend',
			triggerCount: this.state.otpTriggerCount + 1,
			timeSinceLastTrigger: this.state.time === 60 ? 0 : 60 - this.state.time,
			timeSincePageLoad: currentTime - this.state.pageLoadTime,
		};
		
		if (global.renewConsentId && this.isConsentRenewal === 'true') {
			captureConsentRenewalOtpInputTriggered(otpTriggerMetrics);
		} else {
			captureOtpInputTriggered(otpTriggerMetrics);
		}

		// Increment trigger counter after tracking
		this.setState((prevState) => ({
			otpTriggerCount: prevState.otpTriggerCount + 1,
		}));

		this.getOtp();
		this.setState({ isDisable: true, disableType: 'Resend' });
		this.authApis.userLogin().then(async (res) => {
			console.log('User Login Response From SDK', res)
			if (res?.authType === "SNA") {
				this.props.updateLoginStageLoader({isLoading:true, loadingText:"Securely Authenticating your number..."})
				if (res?.snaPromise) {
					let snaResponse = await res.snaPromise;
					console.log('snaResponse in Login:',JSON.stringify(snaResponse));
					if (snaResponse?.status === "SUCCESS") {
						this.setState({ isDisable: false });
						const token = snaResponse?.token;
						this.verifyOtp(null, nextStep, token);
					} else {
						toast.error('Failed to verify via SIM provider. Please try manually')
						let fallbackResult = snaResponse.fallbackResult;
						console.log('fallback triggered:', fallbackResult);
						this.otpFlowHandler(fallbackResult);
					}
				}else{
					this.otpFlowHandler(res);
				}
			} else {
				this.otpFlowHandler(res);
			}
		});		
	};
	otpFlowHandler = (res) => {
		this.state.loginStage = 'VERIFY_OTP';
		this.setState({ isDisable: false });
		this.props.updateInitialLoader(false);
		this.props.updateLoginStageLoader({ isLoading: false });
		if (res.status === 'SEND') {
			if ('OTPCredential' in window) {
				window.addEventListener('DOMContentLoaded', (e) => {
					const ac = new AbortController();
					navigator.credentials
						.get({
							otp: { transport: ['sms'] },
							signal: ac.signal,
						})
						.then((otp) => {
							this.setState({ OTP: otp });
						})
						.catch((err) => {
							console.log(err);
						});
				});
			} else {
				console.log('WebOTP not supported!.');
			}
			} else if (res?.message?.code === 'C002') {
				this.props.history.push({
					pathname: `/consent-status`,
					state: {
						status: 'Consent Actioned',
						statusCode: 410,
					},
				});
		} else {
				if (res?.code === undefined || res?.code === null || res?.code === "") {
				toast.error(res?.message);
			// this.props.history.push(`/error`);
				} else {
					toast.error(this.props.t(`errors.code.${res.code}`));
				}
			if (res.status === 'FAILURE') {
				postMessage('session', 'FAILURE');
			} else if (res.status === 'ERROR') {
				postMessage('session', 'ERROR');
			}
		}
	};
	
	verifyOtp = (e, nextStep, authToken) => {
		nextStep = nextStep ?? (() => {});
		e?.preventDefault();
		this.setState({ isDisable: true, disableType: 'Verify' });

		// Track verification attempt before incrementing counter
		const currentTime = performance.now();
		const totalTime = currentTime - this.state.pageLoadTime;
		const inputTime = this.hasTrackedInputStart
			? currentTime - this.state.lastInputTime
			: totalTime;

		const verificationAttemptMetrics = {
			attemptNumber: this.state.verificationAttempts + 1,
			totalTime,
			inputTime,
			isComplete: authToken!== null ?? this.state.OTP.length === 6,
		};
		
		if (global.renewConsentId && this.isConsentRenewal === 'true') {
			captureConsentRenewalOtpVerificationAttempt(verificationAttemptMetrics);
		} else {
			captureOtpVerificationAttempt(verificationAttemptMetrics);
		}

		// Increment attempt counter after tracking
		this.setState((prevState) => ({
			verificationAttempts: prevState.verificationAttempts + 1,
		}));
		let verifyToken = (authToken && authToken !== null && authToken !== "") ? authToken : this.state.OTP;
		console.log('state state otp',this.state.OTP, verifyToken, authToken)
		this.authApis.verifyOtp(verifyToken).then((res) => {
			if(authToken && authToken !== null && authToken !== ""){
				this.props.updateLoginStageLoader({ isLoading: false, isSuccess: true, successText: "Verification Successful" });
			}
			// Track verification result
			const resultTime = performance.now();
			const verificationResultMetrics = {
				success: res?.status === 'SUCCESS',
				status: res?.status,
				message: res?.message,
				totalAttempts: this.state.verificationAttempts,
				totalTime: resultTime - this.state.pageLoadTime,
			};
			
			if (global.renewConsentId && this.isConsentRenewal === 'true') {
				captureConsentRenewalOtpVerificationResult(verificationResultMetrics);
			} else {
				captureOtpVerificationResult(verificationResultMetrics);
			}

			if (res?.status && res?.status === 'SUCCESS') {
				if(res.userInfo && res.userInfo.userId){ global.userId = res.userInfo.userId; }
				// Handle review consent flow - approve consent automatically
				if (this.state.reviewConsentFlow) {
					this.handleConsentApproval();
				} else {
					// Regular flow - continue to accounts selection 
					nextStep(1);
					this.allFips();
				}
			} else {
				if (!global?.sdkOptions?.hideAuthToaster) {
					if (res?.code === undefined || res?.code === null || res?.code === "") {
						toast.error(res?.message);
					} else {
						toast.error(this.props.t(`errors.code.${res.code}`));
					}
				} else {
					this.setState({
						errors: { otp: true, message: 'OTP Validation Failed' },
					});
				}
				this.setState({ isDisable: false });
				if (res.status === 'FAILURE') {
					postMessage('session', 'FAILURE');
				} else if (res.status === 'ERROR') {
					postMessage('session', 'ERROR');
				}
			}
		});
	};

	// New method to handle consent approval in review consent flow
	handleConsentApproval = async () => {
		try {
			 // For setting session in backend 
			const cD = await this.authApis.consentRequestDetailsSingle();
			const res = await this.authApis.consentRequestApproveWithConsentId(
				this.state.consentId, 
				'ACCEPT', 
				// only first consent handle id is used
				this.state.consentDetailList[0].consentHandleId, 
				global.entityId
			);

			if (res?.status === 'SUCCESS') {
				toast.success('Consent approved');
				// Navigate to consent status page
				this.props.history.push({
					pathname: `/consent-status`,
					state: {
						status: 'Consent approved',
						statusCode: 200,
					},
				});
			} else {
				toast.error(res?.message || 'Failed to approve consent');
				this.setState({ isDisable: false });
				if (res?.status === 'FAILURE') {
					postMessage('session', 'FAILURE');
				} else if (res?.status === 'ERROR') {
					postMessage('session', 'ERROR');
				}
				// Navigate to error status page
				setTimeout(() => {
					this.props.history.push({
						pathname: `/consent-status`,
						state: {
							status: 'Consent approval failed',
							statusCode: 20,
						},
					});
				}, 1000);
			}
		} catch (error) {
			console.error('Error approving consent:', error);
			toast.error('An error occurred while approving consent');
			this.setState({ isDisable: false });
			setTimeout(() => {
				this.props.history.push({
					pathname: `/consent-status`,
					state: {
						status: 'Consent approval failed',
						statusCode: 20,
					},
				});
			}, 1000);
		}
	};

	getUserdetails = async () => {
		const res = await this.authApis.getUserInfo();
		if (res?.status && res?.status === 'ACCEPT') {
			console.log(res, 'this.getUserdetails');
			global.mobileNumber = res.UserInfo.mobileNo;
			global.userId = res.UserInfo.userId;
			global.pan = res?.UserInfo?.panProvided;
			global.dob = res?.UserInfo?.dobProvided;
			global.mobileNumberArray.push(res.UserInfo.mobileNo);
			this.setState({ mobileNo: res.UserInfo.mobileNo });
			toast.success(`${this.props.t('login.messages.welcomeMessage')} ${global.userId}`);
			return res;
			// return new Promise( res);
		} else {
			if (res?.code === undefined || res?.code === null || res?.code === "") {
				toast.error(res?.message);
			} else {
				toast.error(this.props.t(`errors.code.${res.code}`));
			}
			this.setState({ isDisable: false });
			if (res.status === 'FAILURE') {
				postMessage('session', 'FAILURE');
			} else if (res.status === 'ERROR') {
				postMessage('session', 'ERROR');
			}
		}
	};
	/*otp toggle*/
	getOtp = () => {
		this.setState({ isResend: false, OTP: '' });
		this.id = setInterval(this.initiate, 1000);
	};
	checkOtpValid = () => {
		if (this.state.OTP?.length === 6 || this.state.OTP?.length === 8) {
			return false;
		}
		return true;
	};
	allFips = () => {
		this.authApis.allFipsList().then(async (res) => {
			this.setState({ isDisable: true });
			if (res?.status === 'SUCCESS') {
				global.enabledFips = res?.fipsAll?.filter(
					(fip) => fip.enabled === true
				);
				let objectFormatFip = {};
				for (let i = 0; i < global?.enabledFips.length; i++) {
					objectFormatFip[global.enabledFips[i].fipId] = global.enabledFips[i];
				}
				global.objectFormatFip = objectFormatFip;
				await this.consentRequestDetails();
			} else {
				if (res?.code === undefined || res?.code === null || res?.code === "") {
					toast.error(res?.message);
				} else {
					toast.error(this.props.t(`errors.code.${res.code}`));
				}
				if (res.status === 'FAILURE') {
					postMessage('session', 'FAILURE');
				} else if (res.status === 'ERROR') {
					postMessage('session', 'ERROR');
				}
			}
		});
	};

	consentRequestDetails = async () => {
		this.authApis.consentRequestDetails().then(async (res) => {
			this.props.updateLoader(false);
			if (res.status === 'SUCCESS') {
				await this.authApis.consentRequestDetailsSingle();
				const userDetailsResponse = await this.getUserdetails();
				let mobileNum = userDetailsResponse?.UserInfo?.mobileNo;
				let validConsents = res.consentRequestList.filter(
					(el) => el.status === 'SUCCESS'
				);
				if (global.institutionType === 'LSP') {
					await this.getEntityInfo(validConsents);
				} else {
					const groupedConsents = {};
					for (const consent of validConsents) {
						const consentHash = getFiTypesHash(consent?.fiTypes);
						if (Object.keys(groupedConsents).includes(consentHash)) {
							groupedConsents[consentHash].add(consent);
						} else {
							groupedConsents[consentHash] = new Set().add(consent);
						}
					}
					validConsents = window.finvuClient.rankConsents(validConsents);
					this.context.updateCommonConsentFiTypesGroup(groupedConsents);
					this.context.updateConsentList(validConsents);
				}
			this.setState({ consentList: validConsents });
			global.consentListLength = validConsents?.length;
			global.consent =
				this.state.consentList?.length > 0
					? this.state.consentList[0]
					: validConsents[0];
			
			// Check if this is a consent renewal flow
			if (global.renewConsentId) {
				this.props.history.push({
					pathname: '/consent-renew',
					state: { data: res.consentRequestList },
				});
			} else if (this.fips) {
				this.props.history.push({
					pathname: `/accounts/${mobileNum}/${this.fips}`,
					state: { data: res.consentRequestList },
				});
			} else {
				this.props.history.push({
					pathname: `/accounts/${mobileNum}`,
					state: { data: res.consentRequestList },
				});
			}
			} else {
				if (res?.code === undefined || res?.code === null || res?.code === "") {
					toast.error(res?.message);
				} else {
					toast.error(this.props.t(`errors.code.${res.code}`));
				}
				// this.props.history.push(`/error`)
				if (res.status === 'FAILURE') {
					postMessage('session', 'FAILURE');
				} else if (res.status === 'ERROR') {
					postMessage('session', 'ERROR');
				}
				setTimeout(() => {
					this.props.history.push({
						pathname: `/consent-status`,
						state: {
							statusCode: 20,
						},
					});
				}, 3000);
			}
		});
	};
	getEntityInfo = async (consentRequestList) => {
		for (let i = 0; i < consentRequestList?.length; i++) {
			await this.authApis
				.entityInfo(consentRequestList[i].FIU.id)
				.then((result) => {
					console.log('entity Details - ', result);
					if (result.status === 'SUCCESS') {
						consentRequestList[i].entityInfoDetails = result;
						if (consentRequestList.length - 1 === i) {
							let successConsents = consentRequestList.filter(
								(el) => el.status === 'SUCCESS'
							);
							global.selectedLSP = [...successConsents];
							this.setState({
								consentRequestList: [...successConsents],
								selectedAccounts: successConsents,
							});
							this.props.updateLoader(false);
							this.context.updateConsentList(successConsents);
							console.log(this.context, 'consentContext');
						}
					} else {
						this.props.updateLoader(true);
						if (result?.code === undefined || result?.code === null || result?.code === "") {
							toast.error(result?.message);
						} else {
							toast.error(this.props.t(`errors.code.${result.code}`));
						}
						if (result.status === 'FAILURE') {
							postMessage('session', 'FAILURE');
						} else if (result.status === 'ERROR') {
							postMessage('session', 'ERROR');
						}
					}
				});
		}
	};

	setTheme = (theme) => {
		this.setState({ theme });
	};

	toggleTermsModal = () => {
		const isDesktop = window.innerWidth >= 900;
		if (isDesktop) {
			this.redirectToExternalTerms();
		} else {
			this.setState((prevState) => ({
				showTermsModal: !prevState.showTermsModal,
			}));
		}
	};

	redirectToExternalTerms = () =>
		window.open('https://finvu.in/terms', '', 'width=600,height=600');

	handleClick = () => {
		this.setState({ isDisable: true, disableType: 'Verify' });
	};

	handleSubmit = (event) => {
		event.preventDefault();
		this.setState({ error: '' });
	};

	handleBack = () => {
		postMessage('exit', 'BACK');
		if (global.isRedirect) {
			if (global.redirectUrl?.includes('?')) {
				global.sendBackBtnRes
					? window.location.replace(
							global.redirectUrl +
								'&ecres=' +
								global.encryptedres +
								'&resdate=' +
								global.resDate +
								'&fi=' +
								global.encryptedFiId
					  )
					: window.location.replace(global.redirectUrl);
			} else {
				global.sendBackBtnRes
					? window.location.replace(
							global.redirectUrl +
								'?ecres=' +
								global.encryptedres +
								'&resdate=' +
								global.resDate +
								'&fi=' +
								global.encryptedFiId
					  )
					: window.location.replace(global.redirectUrl);
			}
		}
	};

	isValidMobileNumber = () => {
		const mobileNo = this?.state?.mobileNo.split('@')[0];
		return /^\d{10}$/.test(mobileNo);
	};

	handleOtpInputStart = (interactionType) => {
		if (!this.hasTrackedInputStart) {
			const currentTime = performance.now();
			const timeToFirstInteraction = currentTime - this.state.pageLoadTime;

			const inputStartMetrics = {
				timeToFirstInteraction,
				interactionType,
			};
			
			if (global.renewConsentId && this.isConsentRenewal === 'true') {
				captureConsentRenewalOtpInputStart(inputStartMetrics);
			} else {
				captureOtpInputStart(inputStartMetrics);
			}

			this.hasTrackedInputStart = true;
		}
	};

	handleOtpPaste = (e) => {
		this.handleOtpInputStart('paste');
	};

	handleOtpKeyPress = (e) => {
		if (!this.hasTrackedInputStart) {
			this.handleOtpInputStart('keypress');
		}
	};

	handleOtpChange = (otp) => {
		const newValue = otp;
		const oldLength = this.state.OTP.length;
		const newLength = newValue.length;

		// Track corrections (backspace/delete)
		if (newLength < oldLength) {
			this.setState((prevState) => ({
				correctionCount: prevState.correctionCount + 1,
			}));
		}

		// Track progress if we've reached a milestone
		if (newLength > oldLength && shouldTrackOtpProgress(newLength)) {
			const metrics = calculateOtpProgressMetrics(
				newLength,
				this.state.lastInputTime,
				this.state.pageLoadTime,
				this.state.correctionCount
			);
			
			if (global.renewConsentId && this.isConsentRenewal === 'true') {
				captureConsentRenewalOtpInputProgress(metrics);
			} else {
				captureOtpInputProgress(metrics);
			}
		}

		this.setState({
			OTP: newValue,
			lastInputTime: performance.now(),
			errors: { otp: false, message: '' },
		});
	};
	render() {
		if (!this.props.sdkReady) {
			return (
				<Box sx={{ display: 'flex' }}>
					<CircularProgress />
			 	</Box>
			);
		}
		const { t } = this.props;
		const dynamicOtpPageHeading = getOtpPageHeading([global.entityName, this.state.name, this.state.mobileNo.split('@')[0]], t);
		const dynamicOtpPageSubHeading = getOtpPageSubHeading(this.reviewConsentParams, this.state.consentDetailList, t);

		// Check for dark theme
		const isDark = this.props.customDetails?.darkTheme === true || this.state.theme?.palette?.mode === 'dark';

		const isMobile = window.innerWidth < 900;
		
		return this.state.isExpired ? (
			<Expired />
		) : (
			<StepperContext.Consumer>
				{({ nextStep }) => (
				<>
				{global.isRedirect === 'true' && global.renewConsentId && (
					<IconButton
						onClick={() => this.setState(isMobile ? { showCancelDrawer: true } : { showCancelDialog: true })}
						disableRipple
						sx={{
							position: 'fixed',
							top: isMobile ? '20px' : '25px',
							right: isMobile ? '15px' : '30px',
							zIndex: 1300,
							p: '0.25rem',
							border: '1px solid #CCCCCC',
							backgroundColor: 'transparent',
							color: isDark ? '#FFFFFF' : '#000000',
							'&:hover': {
								backgroundColor: isDark
									? 'rgba(255, 255, 255, 0.1)'
									: 'rgba(0, 0, 0, 0.04)',
							},
						}}
					>
						<CloseIcon sx={{ fontSize: '0.85rem' }} />
					</IconButton>
				)}
						{(global.renewConsentId) && (
							<Box sx={{ 
								width: '100%',
								position: 'fixed',
								top: 'calc(2.3rem + 2rem )',
								left: 0,
								right: 0,
								zIndex: 1000,
								margin: 0,
								padding: 0,
								lineHeight: 0,
								backgroundColor: isDark ? '#161616' : (this.props.customDetails?.secondaryColor || '#fff'),
								'& > div': {
									padding: '12px 20px !important',
								}
							}}>
								<TrustMarker customDetails={this.props.customDetails} noBorderRadius={true} />
							</Box>
						)}
						<Box sx={{
							...loginLeftStyles.container,
							// backgroundColor: isDark ? '#161616' : '#fff',
							color: isDark ? '#fff' : '#000',
							paddingTop: global.renewConsentId ? 'calc(2.3rem + 2.5rem + 8px + 1rem )' : '70px',
							paddingBottom: global.renewConsentId ? '50px' : '0',
							overflow: 'hidden',
							...(this.props?.customDetails?.loginCoverImage && {
								backgroundImage:`url(${this.props?.customDetails?.loginCoverImage})`,
								backgroundPosition:"center",
								backgroundSize:"cover"
							})
						}}>
							<SetTheme
								customDetails={this.props.customDetails}
								setTheme={this.setTheme}
							/>
							<Box sx={{
								...this.state.reviewConsentFlow ? loginStyles.containerWithoutStepper : loginStyles.container,
								backgroundColor: isDark ? '#161616' : '#fff',
								color: isDark ? '#fff' : '#000',
								background:"transparent",
								overflow: 'hidden',
								...(global.renewConsentId && {
									padding: {
										xs: '5rem 1.5rem 4rem 1.5rem',
										sm: '5rem 1.5rem 4rem 1.5rem',
										md: '5rem 5.5rem 6.2rem 5.5rem',
									}
								})
							}}>
				{this.state.reviewConsentFlow ? null : (
				<StepperBar
					login={true}
					customDetails={this.props.customDetails}
				/>
				)}
					<Stack
						spacing={'1rem'}
						justifyContent={{ xs: 'space-between', md: 'flex-start' }}
					>			
								<Stack sx={loginStyles.otpContainer}>
									{this.props.customDetails?.disableHeading !== "true" && <Box width={'100%'} textAlign={'start'}>
										<Typography
											sx={{
												...loginStyles.headingText,
												fontFamily: this.props?.customDetails?.fontFamily,
												color: this.props.customDetails?.primaryTextColor ?? (isDark ? '#fff' : '#000'),
											}}
										>
											{dynamicOtpPageHeading}
										</Typography>
										<Box sx={loginStyles.heading}>
												{!(
													this.props.customDetails?.disableTrustMarkers === "true" ||
													global.disableSubHeading === "true"
												) && <Typography
												maxWidth={'90%'}
												variant="h6"
												sx={{
													...loginStyles.subHeading,
													fontFamily: this.props.customDetails.fontFamily,
													color: this.props.customDetails?.primaryTextColor ?? (isDark ? '#fff' : '#000'),
												}}
											>
												{dynamicOtpPageSubHeading}
											</Typography>}
											{this.state.reviewConsentFlow  ? null : <Link
												textAlign={this.props.customDetails?.disableTrustMarkers || global.disableSubHeading ? 'start' : 'end'}
												variant="button"
												underline="none"
												flex={1}
												color={this.props.customDetails.primaryColor}
												onClick={() => this.setState({ showDetails: true })}
												sx={{
													...loginLeftStyles.help,
													fontFamily: this.props?.customDetails?.fontFamily,
													color: this.props.customDetails?.primaryTextColor ?? (isDark ? '#fff' : '#000'),
												}}
											>
												{t('common.buttons.info')}
											</Link>
											}
										</Box>
									</Box>}
									<Box sx={loginStyles.inputContainer}>
										{
											this.state.loginStage === "VERIFY_OTP" ? <>
											<LoginOtpGroupedField
												value={this.state.OTP} // controlled OTP state
												onChange={(otp) => this.handleOtpChange(otp)} 
												length={6} // 6 separate boxes
												error={this.state.errors?.otp === true} 
												helperText={this.state.errors?.otp === true ? 	<Typography
													color="error"
													fontSize="0.75rem"
													sx={{
														padding: '0px !important',
													}}
												>
													{t('login.messages.otpVerificationFailed')}
												</Typography> : null}
												primaryColor={this.props?.customDetails.primaryColor} 
												fontFamily={this.props?.customDetails.fontFamily} 
												onOtpInputStart={this.handleOtpInputStart}
  												onOtpPaste={this.handleOtpPaste}
  												handleOtpKeyPress={this.handleOtpKeyPress}
												customDetails={this.props?.customDetails}
											/>
											{this.state.time !== 60 ? (
												<Typography
													fontSize={'0.875rem'}
													fontFamily={this.props.customDetails?.fontFamily}
													sx={{
														color: this.props.customDetails?.secondaryTextColor ?? (isDark ? '#7A8185' : '#000'),
													}}
												>
													{t('common.messages.resendOtpIn')}
													<strong
														style={{
															color: this.state.theme?.palette.error.main,
															fontFamily: this.props.customDetails?.fontFamily,
														}}
													>
														{' ' + this.state.time} {t('common.messages.seconds')}
													</strong>
												</Typography>
											) : (
												<Link
													variant="button"
													underline="none"
													color={`${
														this.state.isResend || this.state.isDisable
															? this.props.customDetails?.primaryColor
															: 'grey'
													}`}
													disabled={!this.state.isResend || this.state.isDisable}
													// since here redirectToVersion doesn't matter, set it to false so that otp can be re-sent
													onClick={() => this.sendOtp(false, nextStep)}
													sx={{
														cursor: 'pointer',
														textTransform: 'capitalize',
													}}
												>
													Resend OTP
												</Link>
											)}
											{this.state.reviewConsentFlow ? null : 
										<Box
											padding={'1rem'}
											sx={{
												...loginStyles.otpText,
												color: this.props.customDetails?.secondaryTextColor ?? (isDark ? '#7A8185' : '#000'),
												backgroundColor: isDark ? '#161616' : this.props.customDetails?.secondaryColor,
												border: isDark ? '1px solid #fff' : 'none',
											}}
										>
											{this.isValidMobileNumber() ? (
												<Typography sx={{
													color: this.props.customDetails?.secondaryTextColor ?? (isDark ? '#7A8185' : '#000'),
												}}>
													{t('login.messages.otpSentTo')}{' '}
													{this.state.mobileNo.split('@')[0]}
												</Typography>
											) : (
												<Typography sx={{
													color: this.props.customDetails?.secondaryTextColor ?? (isDark ? '#7A8185' : '#000'),
												}}>
													
													{t('login.messages.otpSentToRegistered')}
												
												</Typography>
											)}
										</Box>
										}
										</> : 
										this.state.loginStage === "PRE_AUTH_CHECK" ? 
										<Box>
											{this.state.isSNAConfigured && (
												<Box sx={{ mb: 2, textAlign: 'start' }}>
													<Typography
														fontSize={'0.875rem'}
														fontFamily={this.props.customDetails?.fontFamily}
														color={this.props.customDetails?.textColor}
														sx={{ mb: 1 }}
													>
														Confirm your mobile number so we can verify it securely with your SIM provider.
														<Link
														variant="button"
														// underline="none"
														color={this.props.customDetails?.primaryColor}
														onClick={() => this.setState({ showSNADrawer: true })}
														sx={{
															marginLeft:"4px",
															cursor: 'pointer',
															textTransform: 'capitalize',
															fontSize: '0.875rem',
															fontFamily: this.props.customDetails?.fontFamily,
														}}
													>
														Know more
													</Link>
													</Typography>
													
												</Box>
											)}
												<Box
													padding={'1rem'}
													sx={{
														...loginStyles.otpText,
														color: this.props.customDetails.textColor,
														backgroundColor:
															this.props.customDetails?.secondaryColor,
													}}
												>
													<Typography>{`${global.mobileNumber ?? "Registered Mobile Number"}`}</Typography>
												</Box>
										</Box>
										: <></>
										}
										
									</Box>
								</Stack>
								<Button
									variant="contained"
									size="large"
									sx={{
										backgroundColor: this.props.customDetails?.ctaBackgroundColor ?? this.props?.customDetails?.primaryColor,
										textTransform: 'capitalize',
										border: `1px solid ${this.props?.customDetails?.ctaBorderColor ?? this.props?.customDetails?.primaryColor}`,
										'&:focus': {
											backgroundColor: this.props.customDetails?.ctaBackgroundColor ?? this.props?.customDetails?.primaryColor,
										},
										'&:hover': {
											backgroundColor: this.props.customDetails?.ctaHoverPrimaryColor ?? this.props?.customDetails?.primaryColor,
											border: this.props.customDetails?.ctaHoverBorderColor ? `1px solid ${this.props.customDetails?.ctaHoverBorderColor}` : `1px solid ${this.props.customDetails?.primaryColor}`,
										},
										'&.Mui-disabled': {
											backgroundColor: isDark ? '#7A8185' : '#E0E0E0',
											color: isDark ? '#161616' : '#9E9E9E',
											border: isDark ? '1px solid #7A8185' : '1px solid #E0E0E0',
										},
										borderRadius: this.props.customDetails?.borderRadius,
										boxShadow: 'none',
										color: this.props.customDetails?.ctaTextColor ?? (isDark ? '#161616' : '#fff'),
									}}
									disabled={
										false
									}
									onClick={(e) => {
										if(this.state.loginStage === 'PRE_AUTH_CHECK'){
											this.sendOtp(false, nextStep);
											this.props.updateLoginStageLoader({isLoading: true, loadingText: ""});
										}
										else if(this.state.loginStage == 'VERIFY_OTP'){
											this.verifyOtp(e, nextStep)
										}
										
									}}
								>
									{t('common.buttons.continue')}
								</Button>
										{!this.state.reviewConsentFlow && global.isRedirect === 'true' && !global.renewConsentId ? (
											<Box
												sx={{
											...loginStyles.backContainer,
										}}
									>
										<Chip
											onClick={this.handleBack}
											sx={{
												fontFamily: this.props.customDetails?.fontFamily,
												borderRadius: this.props.customDetails?.borderRadius,
												color: this.props.customDetails?.primaryTextColor ?? (isDark ? '#fff' : '#000'),
												borderColor: this.props.customDetails?.primaryColor,
												background: isDark ? '#161616' : 'none',
												// border: `1px solid ${this.props.customDetails?.primaryColor}`,
											}}
											label={t('common.buttons.back')}
										/>
									</Box>
								) : null}
								<Typography sx={{
									...loginStyles.tncLabel,
									color: this.props.customDetails?.secondaryTextColor ?? (isDark ? '#7A8185' : '#000'),
								}}>
									{t('common.messages.byContinuing')} Finvu&nbsp;
									<Link
										component={'button'}
										underline="none"
										fontWeight={700}
										sx={{
											color: this.props.customDetails?.primaryTextColor ?? (isDark ? '#fff' : this.props.customDetails?.primaryColor),
											fontFamily: this.props.customDetails?.fontFamily,
										}}
										onClick={this.toggleTermsModal}
									>
										{t('login.titles.termsAndConditions')}
									</Link>
								</Typography>

								<Dialog
									open={this.state.showTermsModal}
									onClose={this.toggleTermsModal}
									fullWidth
									maxWidth="md"
									disableEnforceFocus
									sx={{
										'& .MuiDialog-paper': {
											overflow: 'hidden',
											touchAction: 'auto',
											padding: '0px',
											backgroundColor: isDark ? '#161616' : '#fff',
											color: isDark ? '#fff' : '#000',
										},
									}}
								>
									<DialogContent
										sx={{
											height: { xs: '80vh', sm: '500px' },
											overflow: 'hidden',
											position: 'relative',
											padding: '0px',
											backgroundColor: isDark ? '#161616' : '#fff',
											color: isDark ? '#fff' : '#000',
										}}
									>
										<IconButton
											aria-label="close"
											onClick={this.toggleTermsModal}
											sx={{ 
												position: 'absolute', 
												right: 8, 
												top: 8, 
												zIndex: 2,
												color: isDark ? '#fff' : '#000',
											}}
										>
											<CloseIcon />
										</IconButton>
										<div
											style={{
												width: '100%',
												height: '100%',
												overflow: 'hidden',
												position: 'relative',
												padding: '0px',
											}}
										>
											<iframe
												src="https://finvu.in/terms"
												title="Terms and Conditions"
												width="100%"
												height="100%"
												style={{
													border: 'none',
													position: 'absolute',
													top: 0,
													left: 0,
													width: '100%',
													height: '100%',
												}}
											/>
										</div>
									</DialogContent>
								</Dialog>
							{this.props.customDetails?.disableTrustMarkers !== "true" && <>
								<Box sx={{ display: { xs: 'none', md: 'block' }, height: { md: '12rem' } }} />
								<Box
									sx={{ display: { xs: 'none', sm: 'none', md: 'flex' } }}
								>
									<LoginFooter />
								</Box>
							</>}
					</Stack>

					{this.props.customDetails?.disableTrustMarkers !== "true" && <>
						<Box sx={{ display: { xs: 'block', sm: 'block', md: 'none' }, height: { xs: '9rem', sm: '9rem' } }} />
						<Box sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }}>
							<LoginFooter />
						</Box>
					</>}
						{(global.renewConsentId) && (
							<Footer fixed={true} />
						)}
							{!global.renewConsentId && <Box
								sx={{
									...loginStyles.footerContainer,
									'@media (max-width: 900px)': {
										gap: '8px',
									},
									backgroundColor:this.props?.customDetails?.loginCoverImage ? "transparent": isDark ? '#161616' : '#fff',
									color: isDark ? '#fff' : '#000',
								}}
							>
								<Icon
									component={LockIcon}
									sx={{
										...loginStyles.lockIcon,
										'@media (max-width: 900px)': {
											...loginStyles.lockIconMobile,
										},
										color: isDark ? '#fff' : 'green',
									}}
								/>
								<Typography
									sx={{
										...loginStyles.footerText,
										'@media (max-width: 900px)': {
											fontSize: '10px',
										},
										color: this.props.customDetails?.secondaryTextColor ?? (isDark ? '#7A8185' : this.props.customDetails.textColor),
										fontFamily: this.props?.customDetails?.fontFamily,
									}}
								>
									{global.renewConsentId ? t('common.messages.footerDataSharingMessage') : t('common.messages.secureDataSharing')}
								</Typography>
								<Avatar
									src={finvuLogo}
									sx={{
										width: '64px',
										'@media (max-width: 900px)': {
											width: '48px',
										},
										'& .MuiAvatar-img': { objectFit: 'contain' },
									}}
								/>
							</Box>}
						</Box>
						{this.state.reviewConsentFlow ? null : <LoginRight
							theme={this.state.theme}
							customDetails={this.props.customDetails}
						/>}
					<DialogBox
						open={this.state.showDetails}
						handleClose={() => this.setState({ showDetails: false })}
						boxPadding="1.25rem"
						marginTopChildren={'0.75rem'}
						subTitleMaxWidth="75%"
					>
						<LoginRightContent {...this.props} theme={this.state.theme} />
					</DialogBox>

			<DialogBox
				open={this.state.showCancelDialog}
				handleClose={() => this.setState({ showCancelDialog: false })}
				title={t('consentRenewal.titles.cancelRenewal')}
				subTitle={t('consentRenewal.messages.cancelConfirmation').replace('{fiuName}', global.entityName || 'the FIU')}
				boxPadding="1.5rem"
				subTitleMaxWidth="85%"
				customDetails={this.props.customDetails}
				isConsentRenewal={true}
			>
				<DenyConsent
					handleCancel={() => this.setState({ showCancelDialog: false })}
					handleDeny={this.handleBack}
					isDarkTheme={isDark}
					customDetails={this.props.customDetails}
					denyButtonText={t('common.buttons.yesExitJourney')}
					cancelButtonText={t('common.buttons.noGoBack')}
					isConsentRenewal={true}
				/>
				</DialogBox>

				<Drawer
					open={this.state.showCancelDrawer}
					setOpen={(open) => this.setState({ showCancelDrawer: open })}
					anchor="bottom"
					height="auto"
					customDetails={this.props.customDetails}
					showCloseBtn={false}
				>
					<Box sx={{ 
						padding: '1.5rem 1.5rem 1.5rem 1.5rem',
						fontFamily: this.props.customDetails?.fontFamily,
						backgroundColor: isDark
							? '#161616'
							: this.props.customDetails?.secondaryColor || '#fff',
					}}>
						<Typography
							sx={{
								fontSize: '1rem',
								fontWeight: 600,
								fontFamily: this.props.customDetails?.fontFamily,
								color: isDark ? '#fff' : '#000',
								marginBottom: '0.5rem',
							}}
						>
							{t('consentRenewal.titles.cancelRenewal')}
						</Typography>
						<Typography
							sx={{
								fontSize: '0.875rem',
								fontFamily: this.props.customDetails?.fontFamily,
								color: isDark ? '#B0B0B0' : '#666',
								marginBottom: '2rem',
							}}
						>
							{t('consentRenewal.messages.cancelConfirmation').replace('{fiuName}', global.entityName || 'the FIU')}
						</Typography>
						<DenyConsent
							handleCancel={() => this.setState({ showCancelDrawer: false })}
							handleDeny={this.handleBack}
							isDarkTheme={isDark}
							customDetails={this.props.customDetails}
							denyButtonText={t('common.buttons.yesExitJourney')}
							cancelButtonText={t('common.buttons.noGoBack')}
							isConsentRenewal={true}
						/>
					</Box>
					<Box sx={{ marginBottom: '-1rem' }}>
						<Footer {...this.props} />
					</Box>
				</Drawer>
					
					<Drawer
							open={this.state.showSNADrawer}
							setOpen={(open) => this.setState({ showSNADrawer: open })}
							anchor="bottom"
							height="40vh"
							customDetails={this.props.customDetails}
						>
							<Box sx={{ p: 3, textAlign: 'start' }}>
								<Box sx={{display:"flex", justifyContent:"start", margin:"6px 0", flexDirection:"row"}}>
									<img
											src={"https://cdn.finvu.in/finvulogos/sim_verification.png"}
											alt="logo"
											style={{width:"60px", height:"60px"
											}}
										/>
								</Box>
								<Typography
									variant="h6"
									sx={{
										fontFamily: this.props.customDetails?.fontFamily,
										color: this.props.customDetails?.textColor,
										mb: 2
									}}
								>
									How we verify your number
								</Typography>
								<Typography
									sx={{
										fontFamily: this.props.customDetails?.fontFamily,
										color: this.props.customDetails?.textColor,
										mb: 3,
										lineHeight: 1.6
									}}
								>
									We verify your mobile number automatically with your SIM provider in the background. Quick and secure, no SMS or OTP.
								</Typography>
								<Typography
									sx={{
										fontFamily: this.props.customDetails?.fontFamily,
										color: this.props.customDetails?.textColor,
										mt: 3,
										lineHeight: 1.6
									}}
								>
									Currently supported only by:
								</Typography>
								<Box sx={{display:"flex", flexDirection:"row"}}>
								<img
											src={"https://cdn.finvu.in/finvulogos/jio.svg"}
											alt="logo"
											style={{width:"25px", height:"25px", marginRight:"8px"
											}}
										/>
										<img
											src={"https://cdn.finvu.in/finvulogos/VI.svg"}
											alt="logo"
											style={{width:"25px", height:"25px", marginRight:"8px"
											}}
										/>
										</Box>
								<Typography sx={{
										fontFamily: this.props.customDetails?.fontFamily,
										color: this.props.customDetails?.textColor,
										mt: 3,
										lineHeight: 1.6
									}}>
									Note: In case we are unable to verify your number automatically, you can verify using an OTP.
								</Typography>
								<Button
									variant="contained"
									size="large"
									onClick={() => this.setState({ showSNADrawer: false })}
									sx={{
										mt:3,
										padding:"8px 0",
										width:"100%",
										borderRadius:"6px",
										backgroundColor: this.props.customDetails?.primaryColor,
										textTransform: 'capitalize',
										fontFamily: this.props.customDetails?.fontFamily,
										'&:hover': {
											backgroundColor: this.props.customDetails?.primaryColor,
											opacity: 0.9
										}
									}}
								>
									Understood
								</Button>
							</Box>
						</Drawer>
						</Box>
					</>
				)}
			</StepperContext.Consumer>
		);
	}
}

export default withTranslation(Login);
